<template>
  <div class="flex items-center justify-center h-full">
    <span
      v-if="count > 0"
      class="inline-flex px-2 py-0.5 text-xs font-medium rounded-md bg-red-50 text-red-700"
    >
      {{ count }}
    </span>
    <span v-else class="text-sm text-gray-300">0</span>
  </div>
</template>

<script>
export default {
  name: 'Coding_HoldCountCell',
  props: ['params'],
  computed: {
    count() {
      return this.params.data?.on_hold_count || 0;
    }
  }
};
</script>
